import { get } from "lodash";
import { useCallback, useMemo, useRef } from "react";
import { FieldProps } from "./fields.types";

export function withSingleValue(Component: any): any {
  return ({
    data,
    error,
    field,
    onChange,
  }: { field: any } & FieldProps): JSX.Element => {
    const onChangeRef = useRef(onChange);
    onChangeRef.current = onChange;
    const id = field._id || field.name;
    const value = get(data, id);

    const handleChange = useCallback(
      (key: string, value: any) => onChangeRef.current(key, value),
      [onChangeRef]
    );

    return useMemo(() => {
      return (
        <Component
          value={value}
          field={field}
          error={error}
          onChange={handleChange}
        />
      );
    }, [value, field, error, handleChange]);
  };
}
